import { render, staticRenderFns } from "./lazyblock_aili_products.vue?vue&type=template&id=8c032b2c&scoped=true"
import script from "./lazyblock_aili_products.vue?vue&type=script&lang=js"
export * from "./lazyblock_aili_products.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_aili_products.vue?vue&type=style&index=0&id=8c032b2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c032b2c",
  null
  
)

export default component.exports